import { Box, Button, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { RemoveButton, ReorderButtons, SectionHeading } from 'ContentItemEditor';
import { useFieldArray, useFormContext } from 'FrontRoyalReactHookForm';
import { TextField } from 'FrontRoyalMaterialUiForm';
import { type StreamFormValues } from './StreamEditor.types';

/*
    Two of the three units of space the parent Stack puts between its children. Together with that
    one it makes the gap above the button match the 24px the card leaves below it.
*/
const BUTTON_GAP = 2;

// "What You'll Learn" on the course dashboard.
export default function CourseHighlightsSection() {
    const { control } = useFormContext<StreamFormValues>();
    const { fields, append, remove, move } = useFieldArray({ control, name: 'what_you_will_learn' });

    return (
        <Stack spacing={1}>
            <SectionHeading>Course Highlights</SectionHeading>

            {fields.length > 0 && <Typography variant="body2">Markdown formatting allowed.</Typography>}

            {fields.map((field, index) => (
                <Stack key={field.id} direction="row" spacing={1} sx={{ alignItems: 'flex-start' }}>
                    <TextField
                        name={`what_you_will_learn.${index}.value`}
                        placeholder="Enter goal here"
                        fullWidth
                        multiline
                        slotProps={{ htmlInput: { dir: 'auto' } }}
                    />

                    <Stack direction="row" sx={{ alignItems: 'center' }}>
                        <ReorderButtons index={index} count={fields.length} label="this highlight" onMove={move} />

                        <RemoveButton
                            name="removeLearning"
                            label="Remove this highlight"
                            onClick={() => remove(index)}
                        />
                    </Stack>
                </Stack>
            ))}

            {/* Padding on a wrapper — see EditorCard. On the button itself it would change the
                button's shape. */}
            <Box sx={{ paddingTop: BUTTON_GAP, alignSelf: 'flex-start' }}>
                <Button
                    name="add_what_you_will_learn"
                    variant="contained"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => append({ value: '' })}
                    sx={{ alignSelf: 'flex-start' }}
                >
                    Add Highlight
                </Button>
            </Box>
        </Stack>
    );
}
